export const MEMBERSHIP_VALIDATION_MODES = {
  AGIS: 'agis_mode_membership'
};
